import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'CreateNewProject',
  //   description: 'description of CreateNewProject',
  //   url: '/create-new-project',
  // },
];

export default help;
